import { render, staticRenderFns } from "./ChainSelection.vue?vue&type=template&id=25ea9f97&scoped=true&"
import script from "./ChainSelection.vue?vue&type=script&lang=js&"
export * from "./ChainSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea9f97",
  null
  
)

export default component.exports